module.exports = "/assets/js/13e7fe1b16ef8d268f28abfe1b5c9b64.svg";